import { render } from "./DeleteFromReturnBoxCompleteModal.vue?vue&type=template&id=aa1b5182"
const script = {}

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/returnBox/modal/DeleteFromReturnBoxCompleteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa1b5182"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa1b5182', __exports__)) {
    console.log('reload')
    api.reload('aa1b5182', __exports__)
  }
  
  module.hot.accept("./DeleteFromReturnBoxCompleteModal.vue?vue&type=template&id=aa1b5182", () => {
    console.log('re-render')
    api.rerender('aa1b5182', render)
  })

}


export default __exports__